import React, { FC, HTMLAttributes, useCallback } from 'react';
import classNames from 'classnames';
import BasicModal from '../BasicModal/BasicModal';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/rootReducer';
import { toggleImagePreviewModal } from 'modules/layout/store/actions/layoutActions';
import { Heading } from 'components/ui';
import { t } from 'utils';
import styles from './ImagePreviewModal.module.scss';

export interface IImagePreviewModal extends HTMLAttributes<HTMLDivElement> {}

const ImagePreviewModal: FC<IImagePreviewModal> = (props) => {
  const { className } = props;
  const dispatch = useDispatch();
  const { isOpen, src } = useSelector((state: RootState) => state.layout.imagePreviewModal);
  const rootClassName = classNames(styles.root, className);

  const handleCloseModal = useCallback(() => {
    dispatch(toggleImagePreviewModal(false));
  }, [dispatch]);

  return (
    <BasicModal className={rootClassName} open={isOpen} onClose={handleCloseModal} hasCloseButton>
      <Heading icon='image'>{t('app.screenshot')}</Heading>
      <img className={styles.image} src={src} alt='Application screenshot preview' />
    </BasicModal>
  );
};

export default ImagePreviewModal;
